<template>
  <div>
      <!-- :key="$route.fullPath 用于相同路由不同传参时，识别路由的区别，从而正确的跳转，不过好像会有性能问题 -->
      <!-- <router-view :key="$route.fullPath"></router-view> -->
      <!-- 下面用于设置导航路径展示 -->
      <!-- <el-breadcrumb v-show="$route.path != '/'" separator-class="el-icon-arrow-right">
        <span class="line">|</span>
        <el-breadcrumb-item>心理测评</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: $route.path }">{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb> -->
      <div style="width:200px;background-color:#F4F4F5;overflow-y:auto;">
        <el-menu :default-active="activeIndex" @select="handleSelect" background-color="#F4F4F5" text-color="#606266" active-text-color="#fdb933" :default-openeds=menu_indexs style="margin-top:30px;" router=true>
            <el-submenu index="1">
                <template slot="title">个人中心</template>
                <el-menu-item index="/glyf_user_center/my_profile">我的资料</el-menu-item>
                <el-menu-item index="/glyf_user_center/my_favorites">我的收藏</el-menu-item>
                <el-menu-item index="/glyf_user_center/my_questions">我的提问</el-menu-item>
                <el-menu-item index="/glyf_user_center/tobe_expert">成为专家</el-menu-item>
                <el-menu-item index="/glyf_user_center/my_contents" v-if="logged_role=='expert'">我的修改</el-menu-item>
            </el-submenu>
        </el-menu>
      </div>
      <div style="flex:1;overflow-y:auto;">
        <router-view></router-view>
      </div>
  </div>
</template>

<script>
import getdata from "@/api/getData.js";
import postdata from "@/api/postData.js";

export default {
  created(){
    // 从后台获取用户类型，以便按照用户类型展示对应的菜单项
    let params = {
        task_type: "GLYF",
    }
    getdata.getListP("checklogin", params)
          .then(resp => {
                this.logged_role = resp.data.utype;
          })
          .catch(() => {
                this.logged_role = 'guest';
          })
    // this.my_role = 'common';
    this.activeIndex = this.$route.path; 
  },
  data() {
    return {
      logged_role: '',
      menu_indexs: ['/glyf_user_center/my_profile', '/glyf_user_center/my_favorites', '/glyf_user_center/my_questions', '/glyf_user_center/tobe_expert', '/glyf_user_center/my_contents'],
      activeIndex: '/glyf_user_center/my_profile',
    }
  },
  // watch: {
  //   $route(to, from) {
  //     this.activeIndex = to.path;
  //   }
  // }
}
</script>

<style scoped>
.el-breadcrumb {
  height: 10px;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.line {
  position: absolute;
  color: white;
  border-left: 3px solid red;
  left: 10px;
}
.el-menu {
    border-bottom: none;
}
.el-menu-item {
    font-size: 15px;
    line-height: 40px;
    height: 40px;
}
.el-submenu /deep/ .el-submenu__title {
    font-size: 17px;
    line-height: 45px;
    height: 45px;
    text-align: left;
}
</style>